<button
  class="btn btn-clear"
  [ngClass]="{ 'search-open': showSearch }"
  role="button"
  (click)="toggleShowSearch()"
  id="show-search"
  [attr.aria-label]="(showSearch ? 'pdf.search.buttons.clear' : 'pdf.search.buttons.search') | translate"
  accessibleTooltip
  [tooltip]="(showSearch ? 'pdf.search.buttons.clear' : 'pdf.search.buttons.search') | translate"
  triggers="manual"
  placement="bottom"
  [rlTabIndex]>
  <span class="sr-only">{{ (showSearch ? 'pdf.search.buttons.clear' : 'pdf.search.buttons.search') | translate }}</span>
  <span *ngIf="!showSearch"><i class="fa fa-search" attr.aria-hidden="true"></i></span>
  <span *ngIf="showSearch"><i class="fa fa-times" attr.aria-hidden="true"></i></span>
</button>
<div *ngIf="showSearch" class="search-in-file">
  <div class="search-in-file-content inline-block">
    <div class="search-in-file-input">
      <label class="sr-only" for="search-input">{{ 'pdf.search.placeHolder' | translate }}</label>
      <input rlFocusMe id="search-input" [typeahead]="options" [(ngModel)]="searchTerm" (keyup.enter)="search(searchTerm)" placeholder="{{ 'pdf.search.placeHolder' | translate }}" tabIndex="0" />
    </div>
    <div class="input-btns-box">
      <button
        (click)="search(searchTerm)"
        class="btn btn-primary"
        id="search-in-file"
        tabIndex="0"
        attr.aria-label="{{ 'searchinfile.btn' | translate }}"
        accessibleTooltip
        [tooltip]="'searchinfile.btn' | translate"
        triggers="manual"
        placement="bottom">
        <span class="sr-only">{{ 'searchinfile.btn' | translate }}</span>
        <i class="fa fa-search" attr.aria-hidden="true"></i>
      </button>
    </div>
    <div class="search-in-file-results" *ngIf="showResults">
      <div class="status-row">
        <div class="list-info-item text-muted" role="status">
          <span class="margin-right"
            ><ng-container *ngIf="resultsNum > 0">{{ resultsNum }} / </ng-container>{{ _totalResults }} {{ 'pdf.total.search.results' | translate }}</span
          >
          <button *ngIf="_totalResults > 1 && prevEnabled" class="btn btn-half-clear arrow-btn btn-thin margin-right" id="prev-result" (click)="prevResult()" attr.aria-label="{{ 'searchinfile.prev' | translate }}">
            <span class="sr-only">{{ 'searchinfile.prev' | translate }}</span>
            <i class="fa fa-angle-double-left no-margin" attr.aria-hidden="true"></i>
          </button>
          <button *ngIf="_totalResults > 1 && nextEnabled" class="btn btn-half-clear arrow-btn btn-thin" id="next-result" (click)="nextResult()" attr.aria-label="{{ 'searchinfile.next' | translate }}">
            <span class="sr-only">{{ 'searchinfile.next' | translate }}</span>
            <i class="fa fa-angle-double-right no-margin" attr.aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
